import merge from "lodash.merge";

/**
 * Call to create a theme object for a component. Passing a second argument, imitating a base
 * theme, will merge both objects. Note, the dominant theme should always be passed as the first
 * param, to ensure property precedence if both objects contain a property with the same name.
 * @param theme The dominant theme object.
 * @param mergingTheme A merging (base) theme.
 * @returns A newly constructed theme object.
 */
export function createTheme(theme: any, mergingTheme?: any) {
	return merge({}, mergingTheme, theme);
}
